import * as api from "Api";
import * as actions from "Actions";

export const fetchSettingCollaborators = year => {
  return (dispatch, getState) => {
    const { currentOrganization } = getState().auth;
    const { label } = getState().collaborator.filter;
    dispatch(
      actions.fetchSettingCollaborators(
        api
          .getCollaboratorCapacity(currentOrganization.id, label, year)
          .then(res => {
            return res.data.data;
          })
      )
    );
  };
};

export const fetchCollaborator = (
  collaboratorId,
  collaboratorUid,
  collaboratorErpId
) => (dispatch, getState) => {
  const { currentOrganization } = getState().auth;
  return dispatch(
    actions.fetchCollaborator(
      api.getCollaborator({
        organization: currentOrganization.id,
        id: collaboratorId,
        uid: collaboratorUid,
        erpId: collaboratorErpId
      })
    )
  );
};

export const fetchCollaboratorSettingSuggestions = () => {
  return (dispatch, getState) => {
    const { id } = getState().auth.currentOrganization;
    return dispatch(
      actions.setCollaboratorsSettingSuggestions(
        api.getCollaboratorSettingSuggestions(id)
      )
    );
  };
};

export const updateSettingsCollaborator = (
  {
    id,
    bu,
    zone,
    role,
    regime,
    profile,
    partner,
    nfSpecialProject,
    arrivalDate,
    departureDate,
    workingHours,
    isOfficeWorkPlace,
    openDays,
    backup,
    admin,
    holidayTypes,
    nbrOfRecoveredAnnualHolidays
  },
  year
) => (dispatch, getState) => {
  const { currentOrganization } = getState().auth;
  return dispatch(
    actions.updateSettingsCollaborator(
      api.updateSettingsCollaborator({
        organization: currentOrganization.id,
        id,
        bu,
        zone,
        role,
        regime,
        backup,
        profile,
        partner,
        nfSpecialProject,
        arrivalDate,
        departureDate,
        workingHours,
        isOfficeWorkPlace,
        openDays,
        holidayTypes,
        year,
        admin,
        nbrOfRecoveredAnnualHolidays
      })
    )
  );
};

export const deleteCollaboratorRegime = regimeId => (dispatch, getState) => {
  const { currentOrganization } = getState().auth;
  return dispatch(
    actions.deleteCollaboratorRegime(
      api.deleteCollaboratorRegime({
        organization: currentOrganization.id,
        id: regimeId
      })
    )
  );
};

export const deleteCollaboratorRole = roleId => (dispatch, getState) => {
  const { currentOrganization } = getState().auth;
  return dispatch(
    actions.deleteCollaboratorRole(
      api.deleteCollaboratorRole({
        organization: currentOrganization.id,
        id: roleId
      })
    )
  );
};

export const deleteCollaboratorZone = zoneId => (dispatch, getState) => {
  const { currentOrganization } = getState().auth;
  return dispatch(
    actions.deleteCollaboratorZone(
      api.deleteCollaboratorZone({
        organization: currentOrganization.id,
        id: zoneId
      })
    )
  );
};

export const deleteCollaboratorBu = buId => (dispatch, getState) => {
  const { currentOrganization } = getState().auth;
  return dispatch(
    actions.deleteCollaboratorBu(
      api.deleteCollaboratorBu({
        organization: currentOrganization.id,
        id: buId
      })
    )
  );
};

export const deleteCollaboratorHolidayType = (holidayTypeId, isForced) => (
  dispatch,
  getState
) => {
  const { currentOrganization } = getState().auth;
  return dispatch(
    actions.deleteCollaboratorHolidayType(
      api.deleteCollaboratorHolidayType({
        organization: currentOrganization.id,
        isForced: isForced,
        id: holidayTypeId
      })
    )
  );
};

export const saveCollaboratorRegime = (regime, hrForDay) => (
  dispatch,
  getState
) => {
  const { currentOrganization } = getState().auth;
  return dispatch(
    actions.saveCollaboratorRegime(
      api.saveCollaboratorRegime({
        organization: currentOrganization.id,
        regime: regime,
        hrForDay: hrForDay
      })
    )
  );
};

export const saveCollaboratorRole = role => (dispatch, getState) => {
  const { currentOrganization } = getState().auth;
  return dispatch(
    actions.saveCollaboratorRole(
      api.saveCollaboratorRole({
        organization: currentOrganization.id,
        role: role
      })
    )
  );
};

export const saveCollaboratorZone = zone => (dispatch, getState) => {
  const { currentOrganization } = getState().auth;
  return dispatch(
    actions.saveCollaboratorZone(
      api.saveCollaboratorZone({
        organization: currentOrganization.id,
        zone: zone
      })
    )
  );
};

export const saveCollaboratorBu = bu => (dispatch, getState) => {
  const { currentOrganization } = getState().auth;
  return dispatch(
    actions.saveCollaboratorBu(
      api.saveCollaboratorBu({
        organization: currentOrganization.id,
        bu: bu
      })
    )
  );
};

export const saveCollaboratorHolidayType = holidayType => (
  dispatch,
  getState
) => {
  const { currentOrganization } = getState().auth;
  return dispatch(
    actions.saveCollaboratorHolidayType(
      api.saveCollaboratorHolidayType({
        organization: currentOrganization.id,
        holidayType: holidayType
      })
    )
  );
};

export const fetchCollaboratorAvatars = () => {
  return (dispatch, getState) => {
    const { id } = getState().auth.currentOrganization;
    return dispatch(
      actions.fetchCollaboratorAvatars(
        api.getCollaboratorAvatars(id).then(res => res.data.data)
      )
    );
  };
};

export const fetchDynamicTableCollaborators = () => {
  return (dispatch, getState) => {
    const { currentOrganization } = getState().auth;
    const {
      filter: { year }
    } = getState().budget.dynamicTable;

    dispatch(
      actions.fetchDynamicTableCollaborators(
        api
          .getDynamicTableCollaborators(
            currentOrganization.id,
            year ? year.split("/")[0] : new Date().getFullYear().toString()
          )
          .then(res => {
            return res.data.data;
          })
      )
    );
  };
};

export const getGdNotifications = () => {
  return (dispatch, getState) => {
    const { id } = getState().auth.currentOrganization;
    return dispatch(
      actions.fetchGetGdNotifications(
        api.getGdNotifications(id).then(res => res.data)
      )
    );
  };
};



// WEBPACK FOOTER //
// ./src/actions/thunks/collaborator.js